import { render, staticRenderFns } from "./MessageChatMobile.vue?vue&type=template&id=8d20e460&"
import script from "./MessageChatMobile.vue?vue&type=script&lang=js&"
export * from "./MessageChatMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports